import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from 'bookraw/shared/services/user.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private userService: UserService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userService.user != null) {
      return true;
    }

    // loginra navigálás és a cél url-t áadjuk query paramban, hogy login után arra navigáljunk
    this.router.navigate(['/sessions/signin'], { queryParams: { returnUrl: state.url }});
    return false;
  }
}
